import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { config } from '../constants'
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as  commonActions from '../actions/common';
import * as  liveActions from '../actions/liveActions';

class RedirectToLive extends Component {
  constructor(props) {
    super(props)
    this.state = {
      updatePage: "",
      EventName: "",
    }
  }

  updateMethod() {
    this.props.Update();
  }

  // fetchData() {
  //     fetch(config.url.API_URL + '/api/Live/GetLive')
  //         .then((response) => {
  //             return response.json()
  //         })
  //         .then((data) => {
  //             this.setState({ Id: data.Id, EventName: data.EventName, Type: data.Type.replace("type", ""), Fase: data.Fase, Heat: data.Heat });
  //             if (this.validation() === false) {
  //                 this.notify();
  //             }
  //         })
  //         .catch((e) => {
  //             this.setState({ hasError: true })
  //             toast.dismiss();
  //         });
  // }

  validation() {
    const { Id, Type, Fase, Heat } = this.state;

    const location = window.location.pathname + window.location.search;
    if (location === `/TTResults?id=${Id}&fase=${Fase}`) {
      return true;
    } else if (location === `/TTResultsRound1?id=${Id}&fase=${Fase}` && Fase === "1") {
      return true;
    } else if (location === `/ScratchStartResults?id=${Id}&type=${Type}`) {
      return true;
    } else if (location === `/KeirinResults?id=${Id}&type=${Type}`) {
      return true;
    } else if (location === `/PointsRaceResults?id=${Id}&type=${Type}`) {
      return true;
    } else if (location === `/OmniumResults?id=${Id}&type=${Type}`) {
      return true;
    } else if (location === `/SprintResults?id=${Id}&type=${Type}&heat=${Heat}`) {
      return true;
    } else if (location === `/Live`) {
      return true;
    } else {
      return false;
    }
  }

  notify = () => {

    this.props.liveActions.getLive()
      .then(() => {

        toast.dismiss();
        toast.dismiss();
        if (this.props.live.live.raceCode !== null) {
          toast("Current race: " + this.props.live.live.EventName, {
            type: toast.TYPE.SUCCESS,
            position: toast.POSITION.TOP_RIGHT,
            autoClose: false,
            draggable: false,
            closeButton: true,
            closeOnClick: false,
            onClick: () => {

              // const location = window.location.pathname + window.location.search;
              // const urlBase = window.location.protocol + "/" + window.location.host;
              // const urlBase = (window.location.pathname.split("/"))[1];
              // if (location !== "/") {

              window.open("/Live", "_self");
              // }
              // else {
              //   window.open("/Live");
              // }
            }
          });
        }
      });
  };

  componentDidMount() {



    // //Formal Normal
    // this.fetchData();
    // this.connectSignalR();




    // // //Ultimo Recurso
    // setInterval(() => {
    //     this.fetchData();
    //     this.updateMethod();
    // }, 3000);


  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.updatePage !== this.state.updatePage) {
      this.props.commonActions.ResetUpdate();
      this.setState({ updatePage: "" });
      this.updateMethod();

      if (window.location.pathname !== "/Live") {
        this.notify();
      }

    }
  }
  // componentDidUpdate(nextProps) {
  //     if (nextProps.message === "Update") {
  //         this.fetchData();
  //         console.log(nextProps.message);
  //         this.props.reset1();

  //     }
  // }


  render() {
    return (
      <div>
        <ToastContainer className="toast-fixed" />
      </div>
    );
  }
}
const mapStateToProps = (completeStore) => {
  return {
    updatePage: completeStore.updatePage,
    live: completeStore.live,
  };
};

const mapDispatchToProps = (dispatch) =>
  ({
    commonActions: bindActionCreators(commonActions, dispatch),
    liveActions: bindActionCreators(liveActions, dispatch),
  });

export default connect(mapStateToProps, mapDispatchToProps)(RedirectToLive);